var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainArea OperateBox"},[_c('div',{staticClass:"mainHeadContent"},[_c('BreadCrumb')],1),_vm._v(" "),_c('div',{staticClass:"mainBodyContent"},[_vm._v("\r\n              操作箱格\r\n      ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-554f222c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page/Maintain/DeviceMaintain/OperateBox.vue
// module id = null
// module chunks = 